import cn from 'classnames'

import { useEffect, useState } from 'react'

import { IUserDevice } from '../../../../../../../store/fetchers/users/types'

import { getDevices } from '../../../../../../../store/fetchers/users'

import { useAppSelector } from '../../../../../../../store/hooks'

import { selectedUser } from '../../../../../../../store/reducers/users'

import { ILoginHistoryProps } from './login-history.props'
import styles from './styles.module.scss'
import ArrowIcon from './icons/arrow.svg'
import PhoneIcon from './icons/phoneIcon.svg'
import DesktopIcon from './icons/desktopIcon.svg'
import UnknownIcon from './icons/unknownIcon.svg'
import { useTranslation } from 'utils/use-translation'

export default function LoginHistory({ className }: ILoginHistoryProps) {
  const { t } = useTranslation()
  
  const [isHidden, setIsHidden] = useState<boolean>(true)
  const [devices, setDevices] = useState<IUserDevice[]>([])
  const [isFetched, setIsFetched] = useState<boolean>(false)
  const user = useAppSelector(selectedUser)
  const [screenWidth, setScreenWidth] = useState<number>(0)

  const fetchDevices = async () => {
    const res = await getDevices()
    setDevices(res)
    setIsFetched(true)
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setScreenWidth(window.innerWidth)
    }
  }, [])

  useEffect(() => {
    if (user) {
      fetchDevices()
    }
  }, [user])

  return (
    isFetched &&
    devices.length !== 0 && (
      <section className={cn(styles.sessions, className, { [styles.hidden]: isHidden })}>
        <h2>{t('active_sessions')}</h2>
        <div className={cn(styles.history, styles.history_first)}>
          <div className={styles.items}>
            <div className={styles.item}>
              {devices[devices.length - 1].deviceType === 'mobile' && <img src={PhoneIcon} alt="device icon" />}
              {devices[devices.length - 1].deviceType === 'desktop' && <img src={DesktopIcon} alt="device icon" />}
              {devices[devices.length - 1].deviceType === 'unknown' && <img src={UnknownIcon} alt="device icon" />}

              <div className={styles.item__info}>
                <div className={styles.item__info__header}>
                  <p>{devices[devices.length - 1].device}</p>
                  <h5>
                    <span className={styles.desktop}>
                      {new Date(devices[devices.length - 1].date).toLocaleTimeString('en-EN', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                      })}
                    </span>{' '}
                    {new Date(devices[devices.length - 1].date).toLocaleDateString('en-EN', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                    })}
                    <span className={styles.mobile}>
                      {new Date(devices[devices.length - 1].date).toLocaleTimeString('en-EN', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                      })}
                    </span>
                  </h5>
                </div>
                <p className={styles.location}>{devices[devices.length - 1].location?.timezone?.replace('/', ', ')}</p>
                <p className={styles.ip}>IP: {devices[devices.length - 1].ip}</p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.history}>
          <div className={styles.header}>
            <h3>{t('log_in_history')}</h3>
            <button onClick={() => setIsHidden((prev) => !prev)}>
              <img src={ArrowIcon} alt="arrow icon" />
            </button>
          </div>

          <div
            className={styles.items}
            style={{
              maxHeight: `${(screenWidth > 765 ? 800 : 550) / (5 - devices.slice(-5).length)}px`,
            }}
          >
            {devices.slice(-5).map((device, index) => (
              <div key={index} className={styles.item}>
                {device.deviceType === 'mobile' && <img src={PhoneIcon} alt="device icon" />}
                {device.deviceType === 'desktop' && <img src={DesktopIcon} alt="device icon" />}
                {device.deviceType === 'unknown' && <img src={UnknownIcon} alt="device icon" />}

                <div className={styles.item__info}>
                  <div className={styles.item__info__header}>
                    <p>{device.device}</p>
                    <h5>
                      <span className={styles.desktop}>
                        {new Date(device.date).toLocaleTimeString('en-EN', {
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: false,
                        })}
                      </span>{' '}
                      {new Date(device.date).toLocaleDateString('en-EN', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                      })}
                      <span className={styles.mobile}>
                        {new Date(device.date).toLocaleTimeString('en-EN', {
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: false,
                        })}
                      </span>
                    </h5>
                  </div>
                  <p className={styles.location}>{device.location?.timezone?.replace('/', ', ')}</p>
                  <p className={styles.ip}>IP: {device.ip}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    )
  )
}
